// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"EH-z","carouselContainer":"FH-z"};